module.exports = __webpack_public_path__ + "static/img/v001.920eeac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old_sites/v001.png
// module id = gSAV
// module chunks = 1